import { tickerItems } from '../data';

function strip() {
  return tickerItems.map((item, idx) => (
    <span key={idx} className="inline-flex items-center">
      <span className="mx-5 inline-flex items-center gap-2 text-sm">
        <i className="ri-sparkling-2-line text-background-50/80"></i>
        {item}
      </span>
      <span className="text-background-50/40">◆</span>
    </span>
  ));
}

export default function TickerBar() {
  const items = strip();

  return (
    <div className="flex w-full items-stretch overflow-hidden bg-primary-600 text-background-50">
      <div className="flex shrink-0 items-center gap-1.5 bg-primary-700 px-4 py-2.5 text-sm font-bold tracking-wide">
        <span className="live-dot text-background-50">
          <span className="block h-2 w-2 rounded-full bg-background-50"></span>
        </span>
        实时
      </div>
      <div className="relative flex-1 overflow-hidden">
        <div className="ticker-track py-2.5 text-background-50/95">
          {items}
          {items}
        </div>
      </div>
      <div className="hidden shrink-0 items-center gap-1.5 bg-primary-700 px-4 text-sm font-medium sm:flex">
        <i className="ri-time-line"></i>
        <span className="live-dot inline-block h-1.5 w-1.5 rounded-full bg-background-50" />
        今日持续更新
      </div>
    </div>
  );
}